import { InlineNotificationCombinedProps } from './types';

const usePresenter = (props: InlineNotificationCombinedProps): InlineNotificationCombinedProps => {
  return props;
};

export default usePresenter;
